<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<div *ngIf="!loading">

  <!-- Header -->
  <div class="ev-header mb-4">
    <a class="ev-back-btn" [routerLink]="['/', langSrcSrv.current.shortCode, 'learning', 'dashboard']">
      <i class="fa-solid fa-arrow-left"></i>
      <span translate>Accueil</span>
    </a>
    <h2 class="ev-page-title" translate>Test de positionnement</h2>
    <div class="ev-header-spacer"></div>
  </div>

  <!-- No history: first time -->
  <ng-container *ngIf="!history.length">
    <p class="ev-intro" translate>Comment veux-tu commencer ton apprentissage ?</p>

    <div class="ev-choices">

      <div class="ev-choice-card" (click)="play()">
        <div class="ev-choice-icon ev-choice-icon-beginner">
          <i class="fa-solid fa-seedling"></i>
        </div>
        <div class="ev-choice-body">
          <div class="ev-choice-title" translate>Je suis débutant.e</div>
          <div class="ev-choice-sub" translate>Pas de test. Tu démarres au premier niveau et progresses pas à pas.</div>
        </div>
        <i class="fa-solid fa-chevron-right ev-choice-arrow"></i>
      </div>

      <div class="ev-choice-card" [routerLink]="['start']">
        <div class="ev-choice-icon ev-choice-icon-test">
          <i class="fa-solid fa-brain"></i>
        </div>
        <div class="ev-choice-body">
          <div class="ev-choice-title" translate>Je veux tester mon niveau</div>
          <div class="ev-choice-sub" translate>Test de quelques minutes pour être placé directement au bon niveau.</div>
        </div>
        <i class="fa-solid fa-chevron-right ev-choice-arrow"></i>
      </div>

    </div>

    <!-- Platform discovery -->
    <div class="ev-discover">
      <button type="button" class="ev-discover-btn" (click)="openPlatformInfo()">
        <i class="fa-solid fa-circle-info"></i>
        <span translate>Découvre comment fonctionne la plateforme</span>
        <i class="fa-solid fa-arrow-right ev-discover-arrow"></i>
      </button>
    </div>
  </ng-container>

  <!-- Has history: show past tests -->
  <ng-container *ngIf="history.length">

    <p class="ev-intro" translate>Retrouve ci-dessous tes tests de positionnement effectués.</p>

    <div class="ev-history-list mb-4">
      <div class="ev-history-item" *ngFor="let item of history; trackBy: trackByIndex">
        <div class="ev-history-icon">
          <i class="fa-solid fa-clipboard-check"></i>
        </div>
        <div class="ev-history-body">
          <div class="ev-history-level">{{ item.level.name }}</div>
          <div class="ev-history-date">{{ item.date | date:'dd/MM/yyyy' }}</div>
        </div>
        <span class="ev-history-badge" *ngIf="item.cefrl">{{ item.cefrl }}</span>
      </div>
    </div>

    <div class="text-center">
      <a class="ev-btn-retake" [routerLink]="['start']">
        <i class="fa-solid fa-rotate-right"></i>
        <span translate>Repasser le test</span>
      </a>
    </div>

  </ng-container>

</div>
